var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119.628,
    height: 44.082,
    viewBox: "0 0 119.628 44.082",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Big_arrow",
    "data-name": "Big arrow",
    transform: "translate(-535.962 -321.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34568",
    "data-name": "Path 34568",
    d: "M10572.635-9244.475s30.945,33.079,64.736,28.455,48.753-42.939,48.753-42.939",
    transform: "translate(-10031 9581)",
    fill: "none",
    stroke: "#f60",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M1479.977,393l6.391,6.391,6.391-6.391",
    transform: "matrix(-0.719, 0.695, -0.695, -0.719, 1888.06, -409.155)",
    fill: "none",
    stroke: "#f60",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigarrow);
export default __webpack_public_path__ + "static/media/Big arrow.fd2bbdbc8a87b6c958b8625408b90639.svg";
export { ForwardRef as ReactComponent };